export const getFrbAuthorizationHeaders = () => {
  const appContext = window.AppContext;
  return {
    'amazon-advertising-api-clientid': appContext.advertisingApiClientId as string,
    'amazon-advertising-api-csrf-data': appContext.advertisingApiClientId as string,
    'amazon-advertising-api-marketplaceid': appContext.marketplaceId as string,
    'amazon-advertising-api-csrf-token': appContext.advertisingApiCsrfToken as string,
    'x-use-obfuscated-ids': true as boolean,
    'amazon-advertising-api-isportalserver': window.isMidwayAuthenticated as boolean
  };
};

export const getAmcAuthorizationHeaders = () => {
  const appContext = window.AppContext;
  return {
    'amazon-advertising-api-clientid': appContext.advertisingApiClientId as string,
    'amazon-advertising-api-csrf-data': appContext.advertisingApiClientId as string,
    'amazon-advertising-api-csrf-token': appContext.advertisingApiCsrfToken as string,
    'amazon-advertising-api-marketplaceid': appContext.marketplaceId as string,
    'amazon-advertising-api-advertiserid': 'UNIFIED_REPORTING_ID' // dummy variable
  };
};

export const exponentialBackoffWithJitter = ({
  baseDelay,
  maxDelay,
  maxRetries
}: {
  baseDelay: number;
  maxDelay: number;
  maxRetries: number;
}) => ({
  backoff: async (attempt: number) => {
    const delay = Math.min(maxDelay, baseDelay * 2 ** attempt);
    const jitter = Math.random() * delay;
    const timeout = delay + jitter;
    await new Promise(resolve => setTimeout((res: any) => resolve(res), timeout));
  },
  retryCondition: (error: { status: string | number; data?: unknown; error?: string }, args: any, extraArgs: { attempt: number }) => {
    if (extraArgs.attempt >= maxRetries) {
      return false;
    }
    return error.status >= 500 || error.status === 'TIMEOUT_ERROR' || error.data === 'Network Error' || error.error === 'Network Error';
  }
});
